import { render, staticRenderFns } from "./Matriz.vue?vue&type=template&id=64dc0806&"
import script from "./Matriz.vue?vue&type=script&lang=js&"
export * from "./Matriz.vue?vue&type=script&lang=js&"
import style0 from "./Matriz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Matriz.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VCard,VCardText,VIcon,VToolbar,VToolbarTitle})
